import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { AuthContext } from '@/auth';
import { useToast } from '@/hooks/use-toast';
import { QueryClient } from '@tanstack/react-query';

export const Route = createRootRouteWithContext<{
  auth: AuthContext;
  toast: ReturnType<typeof useToast>['toast'];
  queryClient: QueryClient;
}>()({
  component: MainRoute,
});

function MainRoute() {
  return (
    <div className="relative">
      <div className="h-screen">
        <Outlet />
      </div>
      {import.meta.env.DEV && (
        <>
          <TanStackRouterDevtools />
          <ReactQueryDevtools buttonPosition="top-left" />
        </>
      )}
    </div>
  );
}
